import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=1f214f8c&scoped=true&"
import script from "./Recipe.vue?vue&type=script&lang=ts&"
export * from "./Recipe.vue?vue&type=script&lang=ts&"
import style0 from "./Recipe.vue?vue&type=style&index=0&id=1f214f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f214f8c",
  null
  
)

export default component.exports